import type { ReactNode } from 'react';

import { Dropdown } from '#/components/Dropdown/Dropdown';
import { DropdownFoldMenu } from '#/components/Dropdown/menus/Fold/DropdownFoldMenu';

type Props = {
  renderTrigger: (data: {
    triggerText: ReactNode;
    triggerHref: string;
  }) => ReactNode;
  trackClickedContext: string;
};

export function ApiAndIntegrationsDropdown({
  renderTrigger,
  trackClickedContext,
}: Props) {
  return (
    <Dropdown
      trigger={renderTrigger({
        triggerHref: '/volunteersolutions',
        triggerText: 'API & Integrations',
      })}
      desktopTriggersOnHover
    >
      <DropdownFoldMenu
        left={{
          title: 'Business Solutions',
          columnCountOverride: 1,
          items: [
            {
              iconName: 'cogs',
              title: 'API',
              href: '/en/open-network-api',
              qaId: 'nav-api-link',
              trackClicked: {
                name: 'API',
                context: trackClickedContext,
              },
            },
            {
              iconName: 'puzzle-piece',
              title: 'Search Module',
              href: '/volunteer-search-widget',
              qaId: 'nav-search-module-link',
              trackClicked: {
                name: 'Search Module',
                context: trackClickedContext,
              },
            },
            {
              iconName: 'browser',
              title: 'Volunteer Engagement Pages',
              href: '/en/volunteer-engagement-pages',
              qaId: 'nav-volunteer-engagement-pages-link',
              trackClicked: {
                name: 'Volunteer Engagement Pages',
                context: trackClickedContext,
              },
            },

            {
              iconName: 'building',
              title: 'CSR Partners',
              href: '/csr-services',
              qaId: 'nav-csr-partners-link',
              trackClicked: {
                name: 'Partners',
                context: trackClickedContext,
              },
            },
          ],
        }}
        right={undefined}
      />
    </Dropdown>
  );
}
